module.exports = __webpack_public_path__ + "assets/img/return-5099e174.png";